import {Injectable} from '@angular/core';
import {PolicyScheduleMain} from '../../shared/models/policy.model';
import {EntityState, SignalEntityStore} from '../../shared/state/signal-entity.store';

export interface PolicyScheduleState extends EntityState<PolicyScheduleMain> {
  distinctSummaryList: string[];
  distinctDatasetNineList: string[];
}

@Injectable({ providedIn: 'root' })
export class PolicyScheduleStore extends SignalEntityStore<PolicyScheduleMain, PolicyScheduleState> {
  constructor() {
    super({
      name: 'policy-schedule',
      idKey: 'index',
      initialState: {
        distinctSummaryList: [],
        distinctDatasetNineList: []
      }
    });
  }
}
